module.exports = __webpack_public_path__ + "static/media/99.33a8ada4.png";